import { Action, createReducer, on } from '@ngrx/store';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    resetState
} from './email-template.action';

import { EmailTemplate } from './email-template.model';

export interface EmailTemplateRecordsState {
    listData: any[];
    total: number;
    singleData: EmailTemplate;
    loading: boolean;
    error: any;
}

export const initialState: EmailTemplateRecordsState = {
    listData: [],
    total: 0,
    singleData: null,
    loading: false,
    error: null,
};


export const EmailTemplateRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);